import { StudentModelProps, StudentRequestProps } from "../../types";
import StudentItem from "../components/StudentItem";

export const useStudentsList = (
  requestStudents: StudentRequestProps[],
  students: StudentModelProps[]
) => {
  const studentElements = [];

  for (let i = 0; i < requestStudents.length; i++) {
    studentElements.push({
      element: StudentItem,
      props: {
        index: i,
        studentId: requestStudents[i].id,
        name: students.find((student) => student.id === requestStudents[i].id)
          ?.name,
      },
    });
  }

  return [studentElements];
};
